import { jsxs, jsx } from 'react/jsx-runtime';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, Typography, IconButton } from '@mui/material';
import '@apollo/client';
import '../../../utils/popupUtils.js';
import { makeStyles } from '../../../utils/stylesUtils.js';
/** A dialog title with close button */

var DialogTitleWithClose = function DialogTitleWithClose(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;

  var _useStyles = useStyles(),
      classes = _useStyles.classes;

  return jsxs(DialogTitle, Object.assign({
    className: classes.root
  }, {
    children: [jsx(Typography, Object.assign({
      variant: "h5",
      component: "span"
    }, {
      children: children
    })), jsx(IconButton, Object.assign({
      "aria-label": "close",
      className: classes.closeButton,
      onClick: onClose,
      size: "large"
    }, {
      children: jsx(CloseIcon, {})
    }))]
  }));
};

var useStyles = makeStyles()(function (theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing(2, 3)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
});
export { DialogTitleWithClose };